import { useMemo } from 'react'

import { useApiClient } from 'clients/yogi-api'
import { NotificationsService } from 'features/notifications/service/service'

export { NotificationsService } from 'features/notifications/service/service'
export type * from 'features/notifications/service/types'

export function useNotificationsService(): NotificationsService {
  const client = useApiClient()
  return useMemo(() => new NotificationsService(client), [client])
}
